import { type SvgIconProps } from '@mui/material';
import React from 'react';

function BillsIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0H0V9H12V0ZM6 6.75C7.24265 6.75 8.25 5.74265 8.25 4.5C8.25 3.25735 7.24265 2.25 6 2.25C4.75735 2.25 3.75 3.25735 3.75 4.5C3.75 5.74265 4.75735 6.75 6 6.75Z"
        fill="#232729"
      />
      <path d="M13.5 2.25H15V12H2.25V10.5H13.5V2.25Z" fill="#232729" />
    </svg>
  );
}

export default BillsIcon;
